import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, TeaserView } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomTeasersQuery(
	guid: Guid | undefined,
	options?: Omit<UseQueryOptions<TeaserView, unknown, TeaserView, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Teasers.Root(guid),
		() => AxiosUtils.getResponseData<TeaserView>(api.get(CerebroApiEndpoints.Teasers.Root(guid))),
		options
	);
}
